"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSO_DOMAINS = exports.isLocal = exports.isStaging = exports.isProd = exports.isCustomDomain = exports.isLocalDomain = exports.isStagingDomain = exports.isProdDomain = exports.ENV = void 0;
const appOrigin = window.location.hostname;
const strEndsWith = (str, search) => {
    const strLen = str.length;
    return str.substring(strLen - search.length, strLen) === search;
};
const isProdDomain = strEndsWith(appOrigin, 'hotmart.com');
exports.isProdDomain = isProdDomain;
const isStagingDomain = strEndsWith(appOrigin, 'buildstaging.com');
exports.isStagingDomain = isStagingDomain;
const isLocalDomain = appOrigin === 'localhost';
exports.isLocalDomain = isLocalDomain;
const isCustomDomain = !isProdDomain && !isStagingDomain && !isLocalDomain;
exports.isCustomDomain = isCustomDomain;
var SSO_DOMAINS;
(function (SSO_DOMAINS) {
    SSO_DOMAINS["SSO_STAGING"] = "https://sso.buildstaging.com";
    SSO_DOMAINS["SURROGATE_STAGING"] = "https://sso-surrogate.buildstaging.com";
    SSO_DOMAINS["SSO_PRODUCTION"] = "https://sso.hotmart.com";
    SSO_DOMAINS["SURROGATE_PRODUCTION"] = "https://sso-surrogate.hotmart.com";
})(SSO_DOMAINS || (SSO_DOMAINS = {}));
exports.SSO_DOMAINS = SSO_DOMAINS;
var ENVS;
(function (ENVS) {
    ENVS["STAGING"] = "STAGING";
    ENVS["PRODUCTION"] = "PRODUCTION";
})(ENVS || (ENVS = {}));
const ENV = isProdDomain ? ENVS.PRODUCTION : ENVS.STAGING;
exports.ENV = ENV;
const isProd = ENV === ENVS.PRODUCTION;
exports.isProd = isProd;
const isStaging = ENV === ENVS.STAGING;
exports.isStaging = isStaging;
const isLocal = process.env.NODE_ENV === 'development';
exports.isLocal = isLocal;
